import { produce } from 'immer';
import { convertToTimeZone } from 'uikit/datePicker/DatePicker';
import * as types from './emailTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    records: [],
    tableHeaders: [],
    totalRecords: 0,
    loading: true,
};

const actionHandlers = {
    [types.GET_EMAILS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_EMAILS.SUCCESS]: produce((draft, { total, emails }) => {
        draft.records = emails.map((item) => ({
            ...item,
            createdBy: `${
                item?.createdBy?.firstName && item?.createdBy?.lastName
                    ? `${item?.createdBy?.firstName} ${item?.createdBy?.lastName} `
                    : item?.createdBy?.email
            }`,
            schedule: !item?.schedule ? '' : convertToTimeZone(item?.schedule),
        }));
        draft.totalRecords = total;
        draft.loading = false;
    }),
    [types.GET_EMAILS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_EMAILS]: produce((draft) => {
        draft.records = [];
        draft.totalRecords = 0;
        draft.loading = true;
    }),
};

export default createReducer(initialState, actionHandlers);
